import React, { useContext, useEffect, useState } from 'react';
import { Card, Grid, Typography, useMediaQuery, Box, Tabs, Tab, Modal, TextField, Chip, InputAdornment, FormControl, InputLabel, MenuItem, Button } from '@mui/material';
import { useStyles } from './style';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import { useNavigate } from 'react-router-dom';
import { AuthUser } from '../../interfaces/Contexts';
import unsplash from '../../Assets/unsplash.png';
import LinkedinImg from '../../Assets/linkedinImg.png';
import EditIcon from '@mui/icons-material/Edit';
import CustomTabPanel from '../../Components/TabsComponent';
import AddIcon from '@mui/icons-material/Add';
import PdfImg from '../../Assets/pdfimg.png';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AppliedJobCards from '../../Components/JobCards';
import { AppButton } from '../../Components/AppButton';
import KenColors from '../../Helpers/Themes/kenColors';
import IdCard from './components/IdCardModel';
import PreferenceModel from './components/PreferenceModel';
import LinkedInModel from './components/LinkedInModel';
import AcademicRecordImg from '../../Assets/AcedemicRecord.png';
import SearchIcon from '@mui/icons-material/Search';
import EventsCard from './components/EventCard';
import CommunityCard from './components/CommunityCard';
import MentorshipCard from './components/MentorshipCard';
import CampaingsCard from './components/CampaingsCard';
import routes from '../../Utils/routes';
import KeyboardBackspaceSharpIcon from '@mui/icons-material/KeyboardBackspaceSharp';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TableContainer from './components/Table';
import AddAcademicRecord from './components/AddAcademicRecord';
import zohoImg from '../../Assets/zohoImg.png';
import googleImg from '../../Assets/googleImg.png';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import AddEmployeeDetails from './components/AddEmployeeDetail';
import AddCertificateData from './components/AddCertificateData';
import AddSkill from './components/AddSkill';
import { useTheme } from '@mui/material/styles';
import { getEventsData } from '../../Utils/apiService';
import { IEventCards } from '../../interfaces/Profile';
import KenLoader from '../../GlobalComponents/KenLoader';
import resumeNoDataImg from '../../Assets/resumeNoData.png';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import {
  getAcademicRecords,
  getBasicProfileSetting,
  getEmployeementDetails,
  getJobPreferenceSetting,
  getJobs,
  getJobsApply,
  getJobsResume,
  getNetworks,
  getProfileCertificateDetails,
} from '../../Utils/apiService';

interface JobTitle {
  title: string;
}
export default function MyProfile() {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const theme = useTheme();
  const navigate = useNavigate();
  // const isMobile = useMediaQuery('(max-width:1025px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [open, setOpen] = useState(false);
  const [openPrefer, setOpenPrefer] = useState(false);
  const [openLinkedIn, setOpenLinkedIn] = useState(false);
  const [openAcademicRecord, setOpenAcademicRecord] = useState(false);
  const [openEmployeeAdd, setOpenEmployeeAdd] = useState(false);
  const [openEmployeeEdit, setOpenEmployeeEdit] = useState(false);
  const [openCertificateAdd, setOpenCertificateAdd] = useState(false);
  const [openCertificateEdit, setOpenCertificateEdit] = useState(false);
  const [openSkillsAdd, setOpenSkillsAdd] = useState(false);
  const [openSkillsEdit, setOpenSkillsEdit] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [eventsData, setEventsData] = useState<any>({
    upcoming: [],
    cancelled: [],
    completed: [],
    filteredUpcoming: [],
    filteredCancelled: [],
    filteredCompleted: [],
  });

  const [value, setValue] = useState(0);
  const [eventStatus, setEventStatus] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState('');
  const [carrierJobs, setCarrierJobs] = useState('AppliedJobs');
  const [academicRecords, setAcademicRecords] = useState('RequestCertificate');
  const [acedmicStatus, setAcademicStatus] = useState(false);
  const [campaignsStatus, setCampaignsStatus] = useState(false);
  const [semester, setSemester] = React.useState('');
  const [eventData, setEventData] = useState('upcoming');
  const [appliedData, setAppliedData] = useState([]);
  const [resumeDataDetails, setResumeDataDetails] = useState([]);
  const [selectedSkillSet, setSelectedSkillSet] = useState<JobTitle[]>([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [employeeDetailVal, setEmployeeDetailVal] = useState([]);
  const [jobsData, setJobsData] = useState([]);
  const [certificateDetails, setCertificateDetails] = useState([]);
  const [certificateDetailVal, setCertificateDetailVal] = useState([]);
  const [linkedIn, setLinkedIn] = useState('');
  const [menteeDetails, setMenteeDetails] = useState([]);
  const [academicRecordData, setAcademicRecordData] = useState([]);
  const [preference, setPreference] = useState([]);
  const [preferenceImg, setPreferenceImg] = useState([]);
  const [preferenceData, setPreferenceData] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [preferStatus, setPreferStatus] = useState(false);
  const [academicRecordStatus, setAcademicRecordStatus] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenPrefer = () => setOpenPrefer(true);
  const handleClosePrefer = () => setOpenPrefer(false);
  const handleOpenLinkedIn = () => setOpenLinkedIn(true);
  const handleCloseLinkedIn = () => setOpenLinkedIn(false);
  const handleOpenAcademicRecord = () => setOpenAcademicRecord(true);
  const handleCloseAcademicRecord = () => setOpenAcademicRecord(false);
  const handleOpenEmployeeAdd = () => setOpenEmployeeAdd(true);
  const handleCloseEmployeeAdd = () => setOpenEmployeeAdd(false);
  const handleOpenEmployeeEdit = () => setOpenEmployeeEdit(true);
  const handleCloseEmployeeEdit = () => setOpenEmployeeEdit(false);
  const handleOpenCertificateAdd = () => setOpenCertificateAdd(true);
  const handleCloseCertificateAdd = () => setOpenCertificateAdd(false);
  const handleOpenCertificateEdit = () => setOpenCertificateEdit(true);
  const handleCloseCertificateEdit = () => setOpenCertificateEdit(false);
  const handleOpenSkillsAdd = () => setOpenSkillsAdd(true);
  const handleCloseSkillsAdd = () => setOpenSkillsAdd(false);
  const handleOpenSkillsEdit = () => setOpenSkillsEdit(true);
  const handleCloseSkillsEdit = () => setOpenSkillsEdit(false);
  const handleChangeSemester = (event: SelectChangeEvent) => {
    setSemester(event.target.value as string);
  };

  const handleSearchChange = (value: any) => {
    if (value === '' || !value) {
      setEventsData({ ...eventsData, filteredUpcoming: eventsData.upcoming || [], filteredCancelled: eventsData.cancelled || [], filteredCompleted: eventsData.completed || [] });
    } else {
      const filteredData = [...eventsData.filteredUpcoming, ...eventsData.filteredCancelled, ...eventsData.filteredCompleted].filter((items: any) => {
        return items.eventTitle.toLowerCase().includes(value.toLowerCase());
      });

      const upcomingEvents = filteredData
        ?.filter((items: any) => {
          return items?.isUpcoming === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      const cancelledEvents = filteredData
        ?.filter((items: any) => {
          return items?.isCancel === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      const pastEvents = filteredData
        ?.filter((items: any) => {
          return items?.ispast === true;
        })
        .map((items: any) => {
          return createRecord(items);
        });

      setEventsData({
        ...eventsData,
        filteredUpcoming: upcomingEvents || [],
        filteredCancelled: cancelledEvents || [],
        filteredCompleted: pastEvents || [],
      });
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClick = () => {
    navigate(routes.jobs);
  };

  const getJobAppliedDetails = () => {
    getJobsApply(userData.applicantId)
      .then((res) => {
        setAppliedData(res.data.appliedJobs);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getJobDetails = () => {
    getJobs(userData.applicantId)
      .then((res) => {
        setJobsData(res.data.myJobs);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getResumeData = () => {
    getJobsResume(userData.applicantId)
      .then((res) => {
        console.log('res68764', res);
        setResumeDataDetails(res.data.contactsWithFiles?.[0]?.files);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getEmployeeDetails = () => {
    getEmployeementDetails(userData.applicantId)
      .then((res) => {
        console.log('res68764234', res);
        setEmployeeDetails(res?.employmentDetails);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getCertificateDetails = () => {
    getProfileCertificateDetails(userData.applicantId)
      .then((res) => {
        console.log('res68764234', res);
        setCertificateDetails(res?.certificateDetails);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getJobPreference = () => {
    getJobPreferenceSetting(userData.applicantId)
      .then((res) => {
        console.log('34654654', res);
        const parseJobTitles = (titlesString: string): JobTitle[] => {
          return titlesString?.split(';').map((title) => ({
            title: title.trim(),
          }));
        };
        const skillset = parseJobTitles(res.jobPreferences.Skill_set__c);
        setSelectedSkillSet(skillset);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getProfileSetting = () => {
    getBasicProfileSetting(userData.applicantId)
      .then((res) => {
        console.log('res6876423432423', res);
        setProfileData(res.accountDetails);
        setLinkedIn(res.accountDetails.LinkedIn_URL__c);
        const data = res.accountDetails.Preferences__c?.split(';');
        console.log('data324', data);
        let preferenceData = res.staticFiles;
        const parsedObject = JSON.parse(preferenceData);
        console.log('parsedObject12', parsedObject);
        const preferData = res?.staticFiles;
        console.log('preferData2324', preferData);
        console.log('Object Keys:', Object.keys(preferData));
        console.log('Keys Array:', data);

        console.log('Type of Input:', typeof preferData);
        const input = JSON.parse(preferData);
        console.log('input656', input);

        const values = data.map((key: any) => {
          console.log(`Searching for key: "${key}"`);
          const value = input[key];
          console.log(`Found value: ${value}`);
          return `data:image/png;base64,${value}`;
        });

        console.log('Result43:', values);
        setPreference(data);
        setPreferenceImg(values);
        setPreferenceData(parsedObject);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getMenteeDetails = () => {
    getNetworks(userData.applicantId)
      .then((res) => {
        console.log('reshghg', res);
        setMenteeDetails(res.data.myMentees);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getAcademicsRecords = () => {
    getAcademicRecords(userData.applicantId)
      .then((res) => {
        console.log('reshghg3534', res);

        setAcademicRecordData(res?.academicRecords);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getJobAppliedDetails();
    getResumeData();
    getJobPreference();
    getEmployeeDetails();
    getJobDetails();
    getCertificateDetails();
    getProfileSetting();
    getMenteeDetails();
    getAcademicsRecords();
  }, [preferStatus, academicRecordStatus]);

  const createRecord = (items: any) => {
    let data: IEventCards = {
      endTime: items?.endTime,
      Id: items?.Id,
      startDate: items?.startDate,
      startTime: items?.startTime,
      eventTitle: items?.eventTitle,
      endDate: items?.endDate,
      isCancel: items?.isCancel,
      ispast: items?.ispast,
      isUpcoming: items?.isUpcoming,
    };

    return data;
  };

  useEffect(() => {
    setLoading(true);

    getEventsData()
      .then((res) => {
        const data = JSON.parse(res?.data);

        const upcomingEvents = data
          ?.filter((items: any) => {
            return items?.isUpcoming === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        const cancelledEvents = data
          ?.filter((items: any) => {
            return items?.isCancel === true;
          })

          .map((items: any) => {
            return createRecord(items);
          });

        const pastEvents = data
          ?.filter((items: any) => {
            return items?.ispast === true;
          })
          .map((items: any) => {
            return createRecord(items);
          });

        setEventsData({
          upcoming: upcomingEvents || [],
          cancelled: cancelledEvents || [],
          completed: pastEvents || [],
          filteredUpcoming: upcomingEvents || [],
          filteredCancelled: cancelledEvents || [],
          filteredCompleted: pastEvents || [],
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  const renderEvents = (status: 'upcoming' | 'completed' | 'cancelled') => {
    switch (status) {
      case 'upcoming':
        return eventsData.filteredUpcoming.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      case 'cancelled':
        return eventsData.filteredCancelled.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      case 'completed':
        return eventsData.filteredCompleted.map((items: IEventCards, index: number) => {
          return (
            <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
              <EventsCard {...items} />
            </Grid>
          );
        });
      default:
        return null;
    }
  };
  console.log('windows12', window.innerWidth);
  const handleDownload = (title: any, pdf: any) => {
    // Replace with your Base64 encoded PDF string
    const base64Data = pdf;
    const fileName = title;

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  };
  return (
    <div>
      {loading && <KenLoader />}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} lg={3} xl={3} md={12}>
          <Card className={classes.profileCard}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} xl={9} lg={9}>
                <Typography className={classes.profileDesignation}>B Tech, Electronics & Engineering</Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={12} xl={3} lg={3}>
                <Typography className={classes.profileDesignation} sx={{ fontWeight: 600 }}>
                  {userData?.graduationYear == null ? userData?.graduationYear : '2019-23'}
                </Typography>
              </Grid>
            </Grid>
            <Button variant="contained" onClick={handleOpen} className={classes.viewidbutton} fullWidth>
              View Alumni ID Card
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <IdCard handleClose={handleClose} />
            </Modal>
          </Card>
          <Card className={classes.profileCard}>
            <Typography className={classes.referenceTitle}>Your preferences</Typography>
            <hr className={classes.hrLine} />
            <Box className={`${classes.preferenceBox} scrollbar-cusgray`}>
              {preference?.map((data, idx) => {
                const imageSrc = preferenceImg[idx];

                if (imageSrc) {
                  return (
                    <Grid container spacing={2} style={{ marginTop: 1 }} key={idx}>
                      <Grid item xs={3} sm={3} md={3} xl={3} lg={3}>
                        <Box sx={{ height: '36px', width: '36px' }}>
                          <img src={imageSrc} alt="image" width="100%" height="100%" />
                        </Box>
                      </Grid>
                      <Grid item xs={9} sm={9} md={9} xl={9} lg={9} mt={1}>
                        <Typography className={classes.profileDesignation}>{data}</Typography>
                      </Grid>
                    </Grid>
                  );
                } else {
                  return null;
                }
              })}
            </Box>
            <Button
              onClick={handleOpenPrefer}
              className={classes.preferBtns}
              sx={{
                backgroundColor: '#E8EBF3',
                '&:hover': {
                  backgroundColor: '#E8EBF3 !important',
                },
                '&:active': {
                  backgroundColor: '#E8EBF3 !important',
                },
                '&:focus': {
                  backgroundColor: '#E8EBF3 !important',
                },
              }}
              fullWidth
            >
              Edit preferences
            </Button>
            <Modal open={openPrefer} onClose={handleClosePrefer} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <PreferenceModel handleClose={handleClosePrefer} preferenceData={preferenceData} profileData={profileData} userData={userData} setPreferStatus={setPreferStatus} />
            </Modal>
          </Card>
          <Card className={classes.profileCard}>
            <img src={LinkedinImg} alt="image" height={'50%'} width={'50%'} />
            <hr className={classes.hrLine} style={{ marginTop: '-5px' }} />
            <Grid
              container
              spacing={2}
              sx={{
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  height: '6vh !important',
                  marginTop: '-16px',
                },
              }}
            >
              <Grid item xs={10} sm={10} md={10} xl={10} lg={10}>
                {openLinkedIn ? (
                  <Typography className={classes.profileDesignation}>Stay connected with Linkedin</Typography>
                ) : (
                  <Typography className={classes.profileDesignation}>{linkedIn}</Typography>
                )}
              </Grid>

              <Grid item xs={2} sm={2} md={2} xl={2} lg={2}>
                <EditIcon
                  onClick={handleOpenLinkedIn}
                  sx={{
                    cursor: 'pointer',
                    fontSize: '16px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      marginTop: '-16px',
                    },
                  }}
                />
                <Modal open={openLinkedIn} onClose={handleCloseLinkedIn} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                  <LinkedInModel handleClose={handleCloseLinkedIn} />
                </Modal>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={9} md={12} xl={9}>
          <Card className={classes.profileCard}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  sx={{
                    width: '100%',
                    bgcolor: '#EAEFFF',
                    '& .MuiTab-root': {
                      textTransform: 'capitalize',
                      '&.Mui-selected': {
                        color: '#373A45',
                      },
                      '&:hover': {
                        color: '#373A45',
                      },
                    },
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#2C58E8',
                    },
                    borderRadius: '8px',
                    fontSize: '15px',
                  }}
                  allowScrollButtonsMobile
                  variant={isMobile ? 'scrollable' : 'fullWidth'}
                  scrollButtons={isMobile ? 'auto' : false}
                  aria-label="responsive tabs example"
                >
                  <Tab
                    label="Career"
                    sx={{
                      fontSize: '12.5px',
                      fontWeight: '500',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                  <Tab
                    label="Academic Records"
                    sx={{
                      fontSize: '12.5px',
                      fontWeight: '500',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                  <Tab
                    label="Events"
                    sx={{
                      fontSize: '12.5px',
                      fontWeight: '500',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                  <Tab
                    label="Community Involvement"
                    sx={{
                      fontSize: '12px',
                      fontWeight: '500',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                  <Tab
                    label="Mentorship"
                    sx={{
                      fontSize: '12.5px',
                      fontWeight: '500',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                  <Tab
                    label="Fundraise"
                    sx={{
                      fontSize: '12.5px',
                      fontWeight: '500',
                      '@media (min-width: 1120px) and (max-width: 1350px)': {
                        fontSize: '9px',
                        fontWeight: '500',
                      },
                      '@media (min-width: 1360px) and (max-width: 1390px)': {
                        fontSize: '11px',
                        fontWeight: '500',
                      },
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <Box
                  sx={{
                    width: '100%',
                    height: '68.5vh',
                    '@media (min-width: 1270px) and (max-width: 1290px)': {
                      height: '80vh !important',
                    },
                    '@media (min-width: 1536px) and (max-width: 1636px)': {
                      height: '67.5vh !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 2000px)': {
                      height: '71.5vh',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '61vh !important',
                    },
                  }}
                  className="scrollbar-cusgray"
                >
                  <Box className={classes.carrierBox}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} xl={8} lg={8}>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <AppButton
                            size="small"
                            variant="contained"
                            className={classes.postJobBtns}
                            others={{ color: eventStatus ? KenColors.kenWhite : KenColors.kenBlack, borderRadius: '6px', height: '27px', width: '108px' }}
                            background={eventStatus ? '' : KenColors.ClientPrimaryGrey}
                            onClick={() => {
                              setEventStatus(true);
                              setCarrierJobs('AppliedJobs');
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              Applied jobs
                            </Typography>
                          </AppButton>

                          <AppButton
                            size="small"
                            variant="contained"
                            className={classes.postJobBtns}
                            others={{ color: eventStatus ? KenColors.kenBlack : KenColors.kenWhite, marginLeft: '10px', borderRadius: '6px', height: '27px', width: '108px' }}
                            background={eventStatus ? KenColors.ClientPrimaryGrey : ''}
                            onClick={() => {
                              setEventStatus(false);
                              setCarrierJobs('PostedByMe');
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              Posted by me
                            </Typography>
                          </AppButton>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                        <Box sx={{ display: 'flex', justifyContent: { xs: 'start', sm: 'start', md: 'end', xl: 'end', lg: 'end' } }}>
                          <AppButton
                            size="small"
                            variant="contained"
                            className={classes.postJobBtns}
                            others={{ color: KenColors.kenBlack, borderRadius: '6px', height: '36px', width: '144px', backgroundColor: '#E8EBF3' }}
                            background={KenColors.ClientPrimaryGrey}
                            onClick={() => navigate(routes.myJobs)}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontWeight: 500,
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '11px !important',
                                },
                              }}
                            >
                              View More
                            </Typography>
                          </AppButton>
                        </Box>
                      </Grid>
                    </Grid>
                    {carrierJobs == 'AppliedJobs' ? (
                      <Grid container spacing={2} sx={{ marginTop: 0.9 }} className={`${classes.myProfileAppliedData} scrollbar-cusgray`}>
                        {appliedData?.slice(0, 3)?.map((val: any) => {
                          return (
                            <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                              <AppliedJobCards value={val} />
                            </Grid>
                          );
                        })}
                      </Grid>
                    ) : (
                      <Grid container spacing={2} sx={{ marginTop: 0.9 }} className={`${classes.myProfileAppliedData} scrollbar-cusgray`}>
                        {jobsData?.slice(0, 3)?.map((val: any) => {
                          return (
                            <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                              <AppliedJobCards value={val} carrierJobs={carrierJobs} />
                            </Grid>
                          );
                        })}
                        {/* <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                          <JobCards carrierJobs={carrierJobs} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                          <JobCards carrierJobs={carrierJobs} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                          <JobCards carrierJobs={carrierJobs} />
                        </Grid> */}
                      </Grid>
                    )}
                  </Box>
                  <Box className={classes.carrierBox}>
                    <Grid container spacing={2}>
                      <Grid item xs={6} sm={6} md={8} xl={8} lg={8}>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <Typography
                            fontWeight={'500'}
                            sx={{
                              fontSize: '15px',
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '12px !important',
                              },
                            }}
                            color={'#373A45'}
                          >
                            Resume Library
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={6} sm={6} md={4} xl={4} lg={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Box className={classes.iconBox} onClick={handleClick}>
                            <AddIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                    <hr className={classes.hrLine} />
                    {resumeDataDetails?.length > 0 ? (
                      <Box>
                        {resumeDataDetails?.map((val: any) => {
                          return (
                            <>
                              <Grid container spacing={2}>
                                <Grid item xs={2} sm={2} md={2} xl={0.7} lg={0.7}>
                                  <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                    <img src={PdfImg} height="100%" width="100%" />
                                  </Box>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} xl={7.3} lg={7.3}>
                                  <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                    <Typography
                                      fontWeight={'500'}
                                      sx={{
                                        fontSize: '15px',
                                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                                          fontSize: '12px !important',
                                        },
                                      }}
                                    >
                                      {val?.title}
                                    </Typography>
                                  </Box>
                                  <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                    {/* <Typography
                                      fontWeight={'400'}
                                      sx={{
                                        fontSize: '10.5px',
                                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                                          fontSize: '10px !important',
                                        },
                                      }}
                                    >
                                      {'Last used on 23/03/2024'}
                                    </Typography> */}
                                  </Box>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                                  <Box sx={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}>
                                    <SaveAltIcon
                                      sx={{
                                        ml: 2,
                                        fontSize: '18px',
                                        mt: 1.5,
                                      }}
                                      onClick={() => handleDownload(val.title, val.base64Data)}
                                    />
                                  </Box>
                                </Grid>
                              </Grid>
                              <hr className={classes.hrLine} />
                            </>
                          );
                        })}
                      </Box>
                    ) : (
                      <Box sx={{ height: '20vh', mt: 5 }} className="scrollbar-cusgray">
                        <img src={resumeNoDataImg} height={'45px'} width={'45px'} />
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 500,
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '10px !important',
                            },
                          }}
                        >
                          You do not have any resumes here
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontWeight: 400,
                            '@media (min-width: 1280px) and (max-width: 1300px)': {
                              fontSize: '10px !important',
                            },
                          }}
                        >
                          Create now!
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box className={classes.carrierBox}>
                    <Grid container spacing={2}>
                      <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <Typography
                            fontWeight={'550'}
                            sx={{
                              fontSize: '16px',
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '12px !important',
                              },
                            }}
                          >
                            Employment Details
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Box className={classes.iconBox} onClick={handleOpenEmployeeAdd}>
                            <AddIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>
                          <Modal open={openEmployeeAdd} onClose={handleCloseEmployeeAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <AddEmployeeDetails handleClose={handleCloseEmployeeAdd} data={'add'} userData={userData} value={''} setPreferStatus={setPreferStatus} />
                          </Modal>
                        </Box>
                      </Grid>
                    </Grid>
                    <hr className={classes.hrLine} />
                    <Box>
                      {employeeDetails?.map((val: any) => {
                        return (
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={3} sm={3} md={3} lg={1} xl={1}>
                              <Box sx={{ height: '48px', width: '48px' }}>
                                <img src={val?.Company__r?.Logo_File_URL__c} height="100%" width="100%" />
                              </Box>
                            </Grid>
                            <Grid item xs={9} sm={9} md={9} lg={6} xl={6}>
                              <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                                <Typography
                                  sx={{
                                    textAlign: 'left',
                                    fontSize: '15px',
                                    fontWeight: 500,
                                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                                      fontSize: '12px !important',
                                    },
                                  }}
                                >
                                  {val.Title__c}
                                </Typography>
                                <Chip label="Currently working here" size="small" sx={{ backgroundColor: '#C1DCC3', fontWeight: 500, fontSize: '12px', color: '#1F4E21', ml: 2 }} />
                              </Box>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontSize: '14px',
                                  fontWeight: 400,
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '12px !important',
                                  },
                                }}
                              >
                                {' '}
                                {val?.Company__r?.Name} | {val.Employment_Type__c}
                              </Typography>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontSize: '12px',
                                  color: '#1A358C',
                                  mt: 2,
                                  fontWeight: 500,
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '10px !important',
                                  },
                                }}
                              >
                                {val?.Location__c}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={3} xl={3} sx={{ display: 'flex', justifyContent: 'end', ml: 5 }}>
                              <CalendarTodayOutlinedIcon sx={{ fontSize: '15px' }} />
                              <Typography
                                sx={{
                                  ml: 1,
                                  fontSize: '12px',
                                  fontWeight: 400,
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '10px !important',
                                  },
                                }}
                              >
                                {val.Start_Date__c} - {val?.End_Date__c}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={1} xl={1} display={'flex'} justifyContent={'end'}>
                              <ModeEditOutlineOutlinedIcon
                                style={{ fontSize: '15px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleOpenEmployeeEdit();
                                  setEmployeeDetailVal(val);
                                }}
                              />
                            </Grid>
                          </Grid>
                        );
                      })}
                      <Modal open={openEmployeeEdit} onClose={handleCloseEmployeeEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <AddEmployeeDetails handleClose={handleCloseEmployeeEdit} data={'edit'} userData={userData} value={employeeDetailVal} setPreferStatus={setPreferStatus} />
                      </Modal>
                    </Box>
                  </Box>
                  <Box className={classes.carrierBox}>
                    <Grid container spacing={2}>
                      <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <Typography
                            fontWeight={'500'}
                            sx={{
                              fontSize: '15px',
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '12px !important',
                              },
                            }}
                          >
                            Certificates
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Box className={classes.iconBox} onClick={handleOpenCertificateAdd}>
                            <AddIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>
                          <Modal open={openCertificateAdd} onClose={handleCloseCertificateAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <AddCertificateData handleClose={handleCloseCertificateAdd} userData={userData} data="add" setPreferStatus={setPreferStatus} value={''} />
                          </Modal>
                        </Box>
                      </Grid>
                    </Grid>
                    <hr className={classes.hrLine} />
                    <Box>
                      {certificateDetails?.map((val: any) => {
                        return (
                          <Grid container spacing={2} sx={{ mt: 0.5 }}>
                            <Grid item xs={2} sm={2} md={2} lg={1} xl={1}>
                              <Box sx={{ height: '48px', width: '48px' }}>
                                <img src={googleImg} height="90%" width="80%" />
                              </Box>
                            </Grid>
                            <Grid item xs={7} sm={7} md={6} lg={6} xl={6}>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontSize: '15px',
                                  fontWeight: 500,
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '12px !important',
                                  },
                                }}
                              >
                                {val.Issuing_Organization__r.Name}
                              </Typography>
                              <Typography
                                sx={{
                                  textAlign: 'left',
                                  fontSize: '12px',
                                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                                    fontSize: '10px !important',
                                  },
                                }}
                              >
                                Google Certifications
                              </Typography>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                              <Chip
                                label={val.Issue_Date__c}
                                sx={{
                                  backgroundColor: '#BFCEFF',
                                  borderRadius: 10,
                                  p: 1,
                                  pt: 1,
                                  pb: 1,
                                  fontSize: '12px',
                                  fontWeight: 500,
                                  ml: { lg: 9, xl: 9 },
                                  color: '#1A358C',
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={2} xl={2} display={'flex'} justifyContent={'end'}>
                              <ModeEditOutlineOutlinedIcon
                                style={{ fontSize: '15px', cursor: 'pointer' }}
                                onClick={() => {
                                  handleOpenCertificateEdit();
                                  setCertificateDetailVal(val);
                                }}
                              />
                            </Grid>
                          </Grid>
                        );
                      })}
                      <Modal open={openCertificateEdit} onClose={handleCloseCertificateEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <AddCertificateData handleClose={handleCloseCertificateEdit} userData={userData} data="edit" setPreferStatus={setPreferStatus} value={certificateDetailVal} />
                      </Modal>
                    </Box>
                  </Box>
                  <Box className={classes.carrierBox}>
                    <Grid container spacing={2}>
                      <Grid item xs={8} sm={8} md={8} xl={8} lg={8}>
                        <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                          <Typography
                            fontWeight={'550'}
                            sx={{
                              fontSize: '15px',
                              '@media (min-width: 1280px) and (max-width: 1300px)': {
                                fontSize: '12px !important',
                              },
                            }}
                          >
                            Skills
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                          <Box className={classes.iconBox} onClick={handleOpenSkillsEdit}>
                            <EditIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>
                          <Modal open={openSkillsEdit} onClose={handleCloseSkillsEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <AddSkill handleClose={handleCloseSkillsEdit} data="edit" />
                          </Modal>

                          <Box className={classes.iconBox} onClick={handleOpenSkillsAdd} sx={{ ml: 1 }}>
                            <AddIcon
                              sx={{
                                fontSize: '18px',
                                display: 'flex',
                                justifyContent: 'center',
                              }}
                            />
                          </Box>
                          <Modal open={openSkillsAdd} onClose={handleCloseSkillsAdd} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <AddSkill handleClose={handleCloseSkillsAdd} data="edit" />
                          </Modal>
                        </Box>
                      </Grid>
                    </Grid>
                    <hr className={classes.hrLine} />
                    <Box sx={{ display: 'flex', justifyContent: 'start', marginTop: '-35px' }}>
                      <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'start', mt: 2 }}>
                        {selectedSkillSet?.map((val: any) => {
                          return (
                            <Chip
                              sx={{
                                backgroundColor: '#E8EBF3',
                                ml: 2,
                                mt: 2,
                                borderRadius: 10,
                                p: 1,
                                fontSize: '12px',
                                fontWeight: 550,
                                '@media (min-width: 1280px) and (max-width: 1300px)': {
                                  fontSize: '10px !important',
                                },
                              }}
                              label={val?.title}
                            />
                          );
                        })}
                      </Grid>
                    </Box>
                  </Box>
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                {academicRecords == 'RequestCertificate' ? (
                  <Box
                    sx={{
                      height: {
                        lg: '68.5vh',
                        xl: '68.5vh',
                        '@media (min-width: 1270px) and (max-width: 1290px)': {
                          height: '80vh !important',
                        },
                        '@media (min-width: 1536px) and (max-width: 1636px)': {
                          height: '67.5vh !important',
                        },
                        '@media (min-width: 1920px) and (max-width: 2000px)': {
                          height: '71.5vh',
                        },
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          height: '61vh !important',
                        },
                      },
                    }}
                    className="scrollbar-cusgray"
                  >
                    {academicRecordData?.map((val: any) => {
                      return (
                        <Box className={classes.academicRecordBox}>
                          <Grid container spacing={2}>
                            <Grid item xs={4} sm={4} md={4} lg={1.5} xl={1.5} xxl={1}>
                              <Box sx={{ height: '72px', width: '72px' }}>
                                <img src={AcademicRecordImg} height="100%" width="100%" />
                              </Box>
                            </Grid>
                            <Grid item xs={8} sm={8} md={8} lg={6} xl={6} xxl={7}>
                              <Typography style={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>{val?.Name_of_the_institute__r?.Name}</Typography>
                              <Typography style={{ textAlign: 'left', fontWeight: 600, fontSize: '10.5px' }}></Typography>
                              <Typography style={{ textAlign: 'left', marginTop: 25, color: '#2C58E8', fontWeight: 500, fontSize: '10.5px' }}>
                                CGPA: {val?.Percentage__c} | {val?.Start_Date__c} - {val?.End_Date__c}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={4.5} xl={4.5} xxl={4} sx={{ display: 'flex', justifyContent: 'start' }}>
                              <AppButton
                                size="small"
                                variant="contained"
                                className={classes.postJobBtns}
                                others={{ color: acedmicStatus ? KenColors.kenWhite : KenColors.kenBlack, height: '27px' }}
                                background={acedmicStatus ? '' : KenColors.ClientPrimaryGrey}
                                onClick={() => {
                                  setAcademicRecords('ViewTranscripts');
                                  setAcademicStatus(true);
                                }}
                              >
                                <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>View transcripts</Typography>
                              </AppButton>

                              <AppButton
                                size="small"
                                variant="contained"
                                className={classes.postJobBtns}
                                others={{ color: acedmicStatus ? KenColors.kenBlack : KenColors.kenWhite, marginLeft: '10px', height: '27px' }}
                                background={acedmicStatus ? KenColors.ClientPrimaryGrey : ''}
                                onClick={() => {
                                  setAcademicStatus(false);
                                  setAcademicRecords('RequestCertificate');
                                }}
                              >
                                <Typography sx={{ fontSize: '10.5px', fontWeight: 500 }}>Request Certificate</Typography>
                              </AppButton>
                            </Grid>
                          </Grid>
                        </Box>
                      );
                    })}

                    <Box sx={{ mt: 5, display: 'flex', justifyContent: 'start' }}>
                      <AppButton
                        size="small"
                        variant="contained"
                        onClick={handleOpenAcademicRecord}
                        className={classes.postJobBtns}
                        others={{ color: '#3061FF', width: 200, height: '36px' }}
                        background="#EAEFFF"
                      >
                        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
                          <AddIcon sx={{ fontSize: '18px', fontWeight: 500 }} />
                          Add Academic Record
                        </Typography>
                      </AppButton>
                      <Modal open={openAcademicRecord} onClose={handleCloseAcademicRecord} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <AddAcademicRecord handleClose={handleCloseAcademicRecord} userData={userData} setAcademicRecordStatus={setAcademicRecordStatus} />
                      </Modal>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      height: {
                        lg: '69.5vh',
                        xl: '69.5vh',
                      },
                      '@media (min-width: 1270px) and (max-width: 1290px)': {
                        height: '80vh !important',
                      },
                      '@media (min-width: 1536px) and (max-width: 1636px)': {
                        height: '68.5vh !important',
                      },
                      '@media (min-width: 1920px) and (max-width: 2000px)': {
                        height: '73vh',
                      },
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        height: '61vh !important',
                      },
                    }}
                  >
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} xl={7} lg={7} sx={{ display: 'flex', justifyContent: 'start', mt: 1 }}>
                          <KeyboardBackspaceSharpIcon
                            sx={{ mt: 0.2, fontSize: '15px' }}
                            onClick={() => {
                              setAcademicRecords('RequestCertificate');
                              setAcademicStatus(false);
                            }}
                          />
                          &nbsp;
                          <Typography sx={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>B Tech, Electronics and Media Technology</Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} xl={5} lg={5} sx={{ display: 'flex', justifyContent: { xs: 'start', sm: 'start', lg: 'end', xl: 'end', md: 'end' } }}>
                          <FormControl sx={{ minWidth: { xs: '100%', sm: '100%', lg: 350, xl: 350, md: 350 } }} size="small">
                            <InputLabel id="demo-simple-select-label">Select Semester</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={semester}
                              label="Select Semester"
                              onChange={handleChangeSemester}
                              sx={{
                                borderRadius: 2,
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#3061FF',
                                },
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderRadius: 2,
                                },
                              }}
                            >
                              <MenuItem
                                value={'Semester I'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester I
                              </MenuItem>
                              <MenuItem
                                value={'Semester II'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester II
                              </MenuItem>
                              <MenuItem
                                value={'Semester III'}
                                sx={{
                                  '&.Mui-selected': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-selected:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:active': {
                                    backgroundColor: 'transparent',
                                  },
                                }}
                              >
                                Semester III
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <TableContainer />
                    </Box>
                  </Box>
                )}
              </CustomTabPanel>
              <CustomTabPanel value={value} index={2}>
                <Box
                  className={classes.eventsCardbox}
                  sx={{
                    height: { lg: '65vh', xl: '67vh' },
                    '@media (min-width: 1270px) and (max-width: 1290px)': {
                      height: '80vh !important',
                    },
                    '@media (min-width: 1536px) and (max-width: 1636px)': {
                      height: '66vh !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 2000px)': {
                      height: '71vh',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '59vh !important',
                    },
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                      <Typography sx={{ textAlign: 'start', fontSize: '15px', fontWeight: 500, mt: 1, ml: 1 }}>Your registered events</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                      <TextField
                        variant="outlined"
                        placeholder="Search..."
                        size="small"
                        sx={{
                          mt: 0.5,
                          borderRadius: '6px',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            height: '36px',
                          },
                          '& .MuiOutlinedInput-input': {
                            fontSize: '12px',
                            padding: '10px 14px',
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '6px',
                          },
                          '& .MuiInputAdornment-root': {
                            borderRadius: '6px',
                          },
                        }}
                        onChange={(e: any) => handleSearchChange(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <Box style={{ display: 'flex', justifyContent: 'start', marginTop: 20 }}>
                    <AppButton
                      size="small"
                      variant="contained"
                      className={classes.postJobBtns}
                      others={{ color: eventData == 'upcoming' ? KenColors.kenWhite : KenColors.kenBlack, height: '27px', borderRadius: '6px' }}
                      background={eventData == 'upcoming' ? '' : KenColors.ClientPrimaryGrey}
                      onClick={() => {
                        setEventData('upcoming');
                      }}
                    >
                      <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Upcoming</Typography>
                    </AppButton>

                    <AppButton
                      size="small"
                      variant="contained"
                      className={classes.postJobBtns}
                      others={{ color: eventData == 'completed' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 10, height: '27px', borderRadius: '6px' }}
                      background={eventData == 'completed' ? '' : KenColors.ClientPrimaryGrey}
                      onClick={() => {
                        setEventData('completed');
                      }}
                    >
                      <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Completed</Typography>
                    </AppButton>
                    <AppButton
                      size="small"
                      variant="contained"
                      className={classes.postJobBtns}
                      others={{ color: eventData == 'cancelled' ? KenColors.kenWhite : KenColors.kenBlack, marginLeft: 10, height: '27px', borderRadius: '6px' }}
                      background={eventData == 'cancelled' ? '' : KenColors.ClientPrimaryGrey}
                      onClick={() => {
                        setEventData('cancelled');
                      }}
                    >
                      <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>Cancelled</Typography>
                    </AppButton>
                  </Box>
                  <Box
                    sx={{
                      mt: 2,
                      height: '50vh',
                      '@media (min-width: 1920px) and (max-width: 1940px)': {
                        height: '55vh',
                      },
                    }}
                    className="scrollbar-cusgray"
                  >
                    <Grid container spacing={2}>
                      {renderEvents(eventData as any)}
                    </Grid>
                  </Box>
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={3}>
                <Box
                  sx={{
                    height: { lg: '66.5vh', xl: '66.5vh' },
                    '@media (min-width: 1270px) and (max-width: 1290px)': {
                      height: '80vh !important',
                    },
                    '@media (min-width: 1536px) and (max-width: 1636px)': {
                      height: '65vh !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 2000px)': {
                      height: '69.5vh',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '58vh !important',
                    },
                  }}
                >
                  <Typography style={{ fontWeight: 550, fontSize: '15px', textAlign: 'left', marginTop: 25 }}>Your Groups</Typography>
                  <CommunityCard />
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={4}>
                <Box
                  sx={{
                    height: { lg: '68.5vh', xl: '68.5vh' },
                    '@media (min-width: 1270px) and (max-width: 1290px)': {
                      height: '80vh !important',
                    },
                    '@media (min-width: 1536px) and (max-width: 1636px)': {
                      height: '67.5vh !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 2000px)': {
                      height: '71.5vh',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      height: '61vh !important',
                    },
                  }}
                >
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <Typography style={{ fontWeight: 500, fontSize: '15px', textAlign: 'left' }}>Your mentees</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={2} xl={2} display={'flex'} justifyContent={'end'}>
                      <Typography sx={{ mt: 1.3, textDecoration: 'underline', color: '#3061FF', fontSize: '10.5px', cursor: 'pointer', fontWeight: 500 }} onClick={() => navigate(routes.mentorship)}>
                        View more
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                      <TextField
                        variant="outlined"
                        placeholder="Search..."
                        size="small"
                        sx={{
                          width: '100%',
                          height: '36px',
                          fontSize: '12px',
                          '& .MuiOutlinedInput-root': {
                            height: '100%',
                            fontSize: '12px',
                            borderRadius: '6px',
                          },
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '6px',
                          },
                          '& .MuiInputAdornment-root': {
                            borderRadius: '6px',
                          },
                          '& .MuiInputBase-input': {
                            fontSize: '12px',
                          },
                        }}
                        value={searchValue}
                        onChange={(e) => handleSearchChange(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon style={{ fontSize: '18px' }} />
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                  <MentorshipCard menteeDetails={menteeDetails} />
                </Box>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={5}>
                <CampaingsCard campaignsStatus={campaignsStatus} setCampaignsStatus={setCampaignsStatus} />
              </CustomTabPanel>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
